import { AxiosInstance } from 'axios'
import { Environment } from '../../../Config/constants'
import { Result } from '../../../Shared/Protocol/protocol-result'
import { IHubOrdersByStatusResponse } from './hub-dashboard.interface'

export class HubDashboardApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public getListTotal = async (endpoint: string): Promise<Result<number>> => {
    try {
      const response = await this.service.get(endpoint, {
        params: {
          page: 1,
          offset: Number(Environment.OFFSET_REGISTERS) || 10,
        },
      })

      return Result.ok(response.data?.total ?? 0)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public getOrdersByStatusAggregated = async (): Promise<Result<IHubOrdersByStatusResponse | null>> => {
    try {
      const response = await this.service.get('/dashboard/hub/orders-by-status')
      return Result.ok(response.data ?? null)
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return Result.ok(null)
      }
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public getOrdersTotalByStatus = async (statuses: string[]): Promise<Result<number>> => {
    try {
      const response = await this.service.get('/orders', {
        params: {
          page: 1,
          offset: 1,
          status: statuses,
        },
      })

      return Result.ok(response.data?.total ?? 0)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }
}
